import { store } from "./redux/store";
import { Provider } from "react-redux";
import { CustomHome } from "./custom/CustomHome/CustomHome";

function App() {
    return (
        <Provider store={store}>
            <CustomHome isMaintenance={false} />
        </Provider>
    );
}

export default App;
